import { Navigate, useSearchParams } from "react-router";
import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";
import { useVerifyEmail } from "@/hooks";

export default function VerificaCorreo() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  const {
    mutate: verifyEmail,
    isPending,
    isSuccess,
    isError,
    error,
    isIdle,
  } = useVerifyEmail();

  if (isPending) {
    return (
      <div className="flex min-h-[50vh] flex-col items-center justify-center gap-4">
        <div className="text-lg">
          <Loader2 className="animate-spin" /> Verificando tu correo
          electrónico...
        </div>
      </div>
    );
  } else if (isSuccess) {
    return <Navigate to="/perfil" />;
  } else if (isError) {
    return (
      <div className="flex min-h-[50vh] flex-col items-center justify-center gap-4">
        <div className="text-lg text-destructive">
          Error al verificar el correo
        </div>
        <div className="text-muted-foreground text-center max-w-md">
          {error?.message}
          <ul className="mt-4 text-sm list-disc list-inside">
            <li>Verifica que el enlace que usaste sea el más reciente</li>
            <li>El enlace puede haber expirado, intenta solicitar uno nuevo</li>
            <li>
              Si el problema persiste, contacta soporte: soporte@bdino.app
            </li>
          </ul>
        </div>
      </div>
    );
  } else if (isIdle) {
    return (
      <div className="flex min-h-[50vh] flex-col items-center justify-center gap-4">
        <div className="text-lg">
          Presione el boton para verificar su correo
        </div>
        <Button onClick={() => verifyEmail({ token: token ?? "" })}>
          Verificar correo
        </Button>
      </div>
    );
  }
}
